import { Component, Inject, OnInit, Optional, Input, ViewEncapsulation } from '@angular/core';
// Ask this --> about material module on importing
import { MatDialogRef, MAT_DIALOG_DATA, MatInputModule } from '@angular/material';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { Subject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { ApiService } from '../../services/api.service';
import { SharedApiService } from '../../services/shared-api.service';
import { DialogData, RadioEventData } from '../../model/data.model';
import lifeQuoteJson from '../../life-config/lifeQuotesConfig.json';
import apiUrlPoint from '../../life-config/apiEndPoints.json';
import lifeProductType from '../../life-config/productCodeConfig.json';
import productConfig from '../../life-config/productCodeConfig.json';
import suitabilityConfig from '../../life-config/suitability-analysis-config.json';
import { SharedDataService } from '../../services/shared-data.service';


// import { EditQuoteModel } from '../../model/edit-quote-modal';

@Component({
    selector: 'app-edit-quote-modal',
    templateUrl: './edit-quote-modal.component.html',
    styleUrls: ['./edit-quote-modal.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class EditQuoteModalComponent implements OnInit {

    editQuote: FormGroup;
    radioEventData: RadioEventData;
    uuid: string;
    proposalId: string;
    // Remove any later - Use Interface / class
    // on getting finla UI add to class
    editQuoteModalJson: any = lifeQuoteJson.editModalInitialJson;
    productType: object = lifeProductType.componentClassName;
    apiUrl: object = apiUrlPoint.apiEndPoints;
    productConf = productConfig.product_type;
    salutations: any = suitabilityConfig["salutations"];
    year: any;
    month: any;
    day: any;
    minAge: number;
    currentDate: any;
    editQuoteMaxDate: any;
    quoteCounter: any;
    imageLoad: any;
    dataObtained: any;
    occupationList: any;
    // editQuoteInfo: EditQuoteModel[];
    comparedQueryParams: any;
    comparedInsurerList: any;

    get formReceievedEditQuote(): FormArray {
        return this.editQuote.get('editQuoteInfo') as FormArray;
    }


    constructor(
        private dialogRef: MatDialogRef<EditQuoteModalComponent>,
        private formbuild: FormBuilder,
        private apiService: ApiService,
        private datePipe: DatePipe,
        private sharedData: SharedApiService,
        private sharedDataService: SharedDataService,

        @Optional() @Inject(MAT_DIALOG_DATA) public data: DialogData,
    ) {
        // this.editModalJson ? this.editModalJson['gender'] : '1'

        // Initilaizing form
        this.editQuote = this.formbuild.group({
            dob: ['', Validators.required],
            genderNo: ['', Validators.required],
            smoke: ['', Validators.required],
            annualIncome: ['', [Validators.required, Validators.pattern(new RegExp('^[0-9,]*$'))]],
            occupation: ['', [Validators.required]],
            salutation: [''],
            firstName: [''],
            middleName: [''],
            // tslint:disable-next-line: max-line-length
            lastName: [''],
        });

        // Calender validation

        this.minAge = 18;
        this.currentDate = new Date();
        this.year = this.currentDate.getFullYear();
        this.month = this.currentDate.getMonth();
        this.day = this.currentDate.getDate();
        this.editQuoteMaxDate = new Date(this.year - this.minAge, this.month, this.day);
        this.dataObtained = data['editQuoteInfo'];
        this.editQuote.patchValue({ annualIncome: this.dataObtained['lifeassured']['annual_income'] });
        this.editQuote.patchValue({ dob: this.dataObtained['lifeassured']['dob'] });
        this.editQuote.patchValue({ smoke: this.dataObtained['lifeassured']['consumes_tobacco'] });
        this.editQuote.patchValue({ genderNo: this.dataObtained['lifeassured']['gender'] });
        this.occupationList = data['occupationList'];
        this.editQuote.patchValue({ occupation: this.dataObtained['lifeassured']['occupation'] });
        if (this.dataObtained['lifeassured']['salutation']) {

            this.editQuote.patchValue({ salutation: this.dataObtained['lifeassured']['salutation'] });
        }

        if(this.dataObtained['lifeassured']['first_name']){

            this.editQuote.patchValue({ firstName: this.dataObtained['lifeassured']['first_name'] });
        }

        if (this.dataObtained['lifeassured']['middle_name']) {

            this.editQuote.patchValue({ middleName: this.dataObtained['lifeassured']['middle_name'] });
        }

        if (this.dataObtained['lifeassured']['last_name']){

            this.editQuote.patchValue({ lastName: this.dataObtained['lifeassured']['last_name'] });
        }

        if (this.dataObtained['lifeassured']['occupation']) {

            this.editQuote.patchValue({ occupation: this.dataObtained['lifeassured']['occupation'] });
        }
        // Retreiving query parms and modify to addrss bar <--- Remove this it is iterated
        this.uuid = data['uuid'],
            this.proposalId = data['proposalId'];


        /**
         * getting selected compare plan query params
         */
        this.sharedDataService.comparisionPlanQueryParams.subscribe(paramsData => {
            this.comparedQueryParams = paramsData['paramList'];
            this.comparedInsurerList = paramsData['quoteList'];
        });

    }


    destroySubject$: Subject<void> = new Subject();
    editModalConfData: object;
    inputValueFromCmp: number | string;
    calValFromCmp: object;
    editModalJson: any;
    annualIncomeInComma: any;
    numberInWords: any;
    annualIncomeData: any;

    // Unable to add private class
    editQuoteResponse: any;


    editModalJsonItems(i: number) {

        // Getting Edit Quote Info Array
        return this.formReceievedEditQuote.controls[i].get('editQuoteInfo') as FormArray;

    }

    nameValidation() {

        const isSaluttaion = this.editQuote.get('salutation');
        const isFirstName = this.editQuote.get('firstName');
        const isMiddleName = this.editQuote.get('middleName');
        const isLastname = this.editQuote.get('lastName');
        const isOccupation = this.editQuote.get('occupation');

        this.editQuote.get('firstName').valueChanges.subscribe(
            (maritalMode: string) => {

                if (this.dataObtained['lifeassured']['first_name']) {

                    // tslint:disable-next-line: max-line-length


                        // tslint:disable-next-line: max-line-length
                        isSaluttaion.setValidators([Validators.required]);
                        isOccupation.setValidators([Validators.required]);
                        isFirstName.setValidators([
                            Validators.required,
                            Validators.minLength(1),
                            Validators.maxLength(20),
                            Validators.pattern(new RegExp('^[a-zA-Z]*$'))]);
                        isMiddleName.setValidators([
                            Validators.minLength(1),
                            Validators.maxLength(20),
                            Validators.pattern(new RegExp('^[a-zA-Z]*$'))]);
                        isLastname.setValidators( [
                            Validators.required,
                            Validators.minLength(1),
                            Validators.maxLength(20),
                            Validators.pattern(new RegExp('^[a-zA-Z]*$'))]);




                    // tslint:disable-next-line: max-line-length


                }

                if (!this.dataObtained['lifeassured']['first_name']) {

                    isSaluttaion.setValidators([]);
                    isFirstName.setValidators([]);
                    isMiddleName.setValidators([]);
                    isLastname.setValidators([]);
                    isOccupation.setValidators([]);

                }


                isSaluttaion.updateValueAndValidity();
                isFirstName.updateValueAndValidity();
                isMiddleName.updateValueAndValidity();
                isLastname.updateValueAndValidity();
                isOccupation.setValidators([]);

            });


    }


    // Retreving value from edit modal form and saving it to modal/Class or pass to api

    saveEditQuote(isvalid: boolean, e: any) {

        e.preventDefault();
        const editQuoteUrl = this.apiUrl['apiV2LifeProposal'];
        const proposalId = this.proposalId;
        const uuid = this.uuid;
        const queryParamsURL = this.apiUrl['update_proposal'];

        // Check edit quote form status
        if (isvalid) {

            const annualIncomeTemp = this.editQuote.get('annualIncome').value;
            if (typeof annualIncomeTemp !== 'number' && (annualIncomeTemp).indexOf(',') > -1) {
                this.annualIncomeData = (this.editQuote.get('annualIncome').value).replace(/,\s?/g, '');
            } else {
                this.annualIncomeData = this.editQuote.get('annualIncome').value;
            }

            let data;
            if (this.dataObtained['product_type'] === 2) {
                 data = {


                    lifeassured: {
                        gender: this.editQuote.get('genderNo').value,
                        dob: this.datePipe.transform(new Date(this.editQuote.get('dob').value), 'yyyy-MM-dd'),
                        annual_income: this.annualIncomeData,
                        consumes_tobacco: this.editQuote.get('smoke').value,
                        salutation: this.editQuote.get('salutation').value,
                        first_name: this.editQuote.get('firstName').value,
                        middle_name: this.editQuote.get('middleName').value,
                        last_name: this.editQuote.get('lastName').value,
                        occupation_id: this.editQuote.get('occupation').value,
                    }

                };
            }

            if(this.dataObtained['product_type'] === 1){
                data = {


                    lifeassured: {
                        gender: this.editQuote.get('genderNo').value,
                        dob: this.datePipe.transform(new Date(this.editQuote.get('dob').value), 'yyyy-MM-dd'),
                        salutation: this.editQuote.get('salutation').value,
                        first_name: this.editQuote.get('firstName').value,
                        middle_name: this.editQuote.get('middleName').value,
                        last_name: this.editQuote.get('lastName').value,
                        occupation_id: this.editQuote.get('occupation').value,
                    }

                };
            }

            // Find smaaller way to send data -so that json can be set in one place

            this.clearComparePlanQueryParams();

            // Exposing data to api
            this.apiService.updateProposal(
                this.apiUrl['apiV2LifeProposal'],
                this.proposalId, this.uuid,
                this.apiUrl['update_proposal'], data).subscribe(res => {
                    this.editQuoteResponse = res['response'];
                    if (this.editQuoteResponse) {

                        this.dialogRef.close({ event: 'close', data: this.editQuoteResponse });
                    }

                }, err => {
                    this.dialogRef.disableClose = true;
                });
        }
    }

    // removing all compare plan query params on updating any of the field
    clearComparePlanQueryParams() {

        if ((this.comparedInsurerList && this.comparedInsurerList.length > 0) &&
            (this.comparedQueryParams && this.comparedQueryParams.length > 0)) {

            this.comparedInsurerList = [];
            this.comparedQueryParams = [];

            this.sharedDataService.setUpdatedQueryParams(this.comparedInsurerList, this.comparedQueryParams);
        }
    }

    ngOnInit() {
        this.nameValidation();
    }

    /**
     * on modal cancel click
     */

    cancelEdit() {

        this.dialogRef.close();

    }


}
